import { useState, useEffect } from 'react';
import API_CONFIG from '../../config/api';

// Announcement banner a Super Admin sets once (see the "Dashboard Banner"
// section in Settings) and every admin/staff member sees at the top of
// their own dashboard — a daily-disbursal-milestone poster, a policy
// change, whatever needs eyes company-wide. Not dismissible — replacing
// or removing it (from Settings) is how it changes for everyone.
export function DashboardBanner({ adminSession }) {
    const [banner, setBanner] = useState(null);

    useEffect(() => {
        if (!adminSession?.userId) return;
        let cancelled = false;
        fetch(`${API_CONFIG.BASE_URL}/api/admin/dashboard-banner`, {
            headers: { 'x-user-id': adminSession.userId }
        })
            .then(res => res.json())
            .then(data => {
                if (cancelled || !data.success || !data.data) return;
                setBanner(data.data);
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, [adminSession?.userId]);

    if (!banner) return null;

    return (
        <div className="dash-banner">
            <img
                src={banner.imageUrl}
                alt="Announcement"
                className="dash-banner-img"
                style={{ objectPosition: `${banner.cropPosition?.x ?? 50}% ${banner.cropPosition?.y ?? 50}%` }}
            />
        </div>
    );
}
